import { Pencil, Minus, Plus } from 'lucide-react';
import ConfirmDeleteDialog from '@/components/ui/ConfirmDeleteDialog';
import React from 'react';
import { useSelector } from 'react-redux';
import BaseContainer from '../../../../components/containers/BaseContainer';
import Bar from '../../../../components/elements/Bar';
import List from '../../../../components/elements/List';

export default function TwoColumnEditableList({ addItem, editItem, removeItem }) {
  const { detail } = useSelector((state) => (state as any).classification);
  const permission = useSelector((state) => state.auth.pagePermission);

  const getDataForAlternativeClassList = () => {
    return (detail?.alternative_classification_set || []).map((ele) => ({
      id: ele.id,
      name: ele?.classification_system?.shortcut,
      value: ele.code,
    }));
  };

  const editButton = (id) => (
    <Pencil
      key={1}
      className="h-4 w-4"
      onClick={() => editItem(id)}
      data-testid={`classification-alt-edit-btn-${id}`}
    />
  );
  const deleteButton = (id) => (
    <ConfirmDeleteDialog title="Opravdu chcete odstranit položku?" onConfirm={() => removeItem(id)}>
      <Minus key={1} className="h-4 w-4" data-testid={`classification-alt-delete-btn-${id}`} />
    </ConfirmDeleteDialog>
  );

  return (
    <BaseContainer margin width={'100%' as any}>
      <Bar
        text={'Alternativní zatřídění'}
        content={
          permission === 2
            ? [
                <Plus
                  key={1}
                  className="h-4 w-4"
                  onClick={() => addItem()}
                  data-testid="classification-alt-add-btn"
                />,
              ]
            : []
        }
      />
      <List data={getDataForAlternativeClassList()} actions={[editButton, deleteButton]} />
    </BaseContainer>
  );
}
